import { useEffect, useState } from 'react';
import { User } from 'src/libs/wa/models/entities/User';
import { UserService } from 'src/libs/wa/services/UserService';

const useAuth = () => {
  const [user, setUser] = useState<User | undefined | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    let unmounted = false;
    (async () => {
      try {
        const user = await new UserService().fetch();
        if (!unmounted) {
          setUser(user); // 未ログインの場合もnew UserService().fetch()は成功するが, user=undefinedとなる
          setIsLoading(false); // ローディング完了
        }
      } catch (_err) {
        if (!unmounted) {
          setUser(undefined);
          setIsLoading(false); // エラーでもローディング完了
        }
      }
    })();
    return () => {
      unmounted = true;
    };
  }, []);

  return { user, isLoading };
};

export { useAuth };
